import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Observable, Observer } from "rxjs";
import { NgxSmartModalComponent } from "ngx-smart-modal";
import { MediaApi, Media } from "src/providers/sdk";
import { UploadService } from "../providers/upload.service";
import * as _ from "lodash";
import Swal from "sweetalert2";

@Component({
  selector: "app-file-browser",
  templateUrl: "./file-browser.component.html",
  styleUrls: ["./file-browser.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class FileBrowserComponent implements OnInit {
  private observer: Observer<any>;

  @ViewChild("myModal") linkModal: NgxSmartModalComponent;
  @ViewChild("uploadInput") uploadInput;

  columns = [{ name: "Nom", prop: "name" }];

  selection = [];

  modalOptions = {
    columns: this.columns,
    reorder: false,
    rowclass: this.getRowClass.bind(this),
    actions: [
      {
        name: "delete",
        handler: async $event => {
          this.on_delete_click();
        },
        iconClassName: "fas fa-trash",
        background: "#ff5c5c",
        display: this.selection.length
      },
      {
        name: "link",
        handler: async $event => {
          let element: HTMLInputElement = document.querySelector(
            'input[type="file"]'
          ) as HTMLInputElement;
          element.click();
        },
        iconClassName: "fas fa-cloud-upload-alt"
      }
    ]
  };

  modalData = [];
  options = {
    picker: false
  };

  private getRowClass(row) {
    const index_currentIds = _.indexOf(this.selection, row.id);
    if (index_currentIds != -1) return "item-selected";
    else return "";
  }

  private async get_all_medias() {
    const medias = await this.mediaApi
      .find({
        fields: {
          data: false
        }
      })
      .toPromise();
    this.modalData = medias;
  }

  private async refresh_all_medias() {
    await this.get_all_medias();
  }

  present(options?): Observable<any> {
    Object.assign(this.options, options);
    this.linkModal.open();
    this.refresh_all_medias();
    return Observable.create(observer => {
      this.observer = observer;
    });
  }

  // At the drag drop area
  // (drop)="onDropFile($event)"
  async onDropFile(event: DragEvent) {
    event.preventDefault();
    await this.uploadService.uploadFiles(event.dataTransfer.files);
    this.refresh_all_medias();
  }

  // At the drag drop area
  // (dragover)="onDragOverFile($event)"
  private onDragOverFile(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  // At the file input element
  // (change)="selectFile($event)"
  public async selectFile(event) {
    const res = await this.uploadService.uploadFiles(event.target.files);
    let element: HTMLInputElement = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    element.value = "";
    this.refresh_all_medias();
  }

  public on_modal_row_click(row) {
    const included = _.indexOf(this.selection, row.id) != -1;
    if (included) this.selection = _.without(this.selection, row.id);
    else if (this.options.picker) {
      this.selection = [];
      this.selection.push(row.id);
    } else if (!this.options.picker) this.selection.push(row.id);
    this.refreshDeleteButton();
  }

  private refreshDeleteButton() {
    let deleteButton = _.find(
      this.modalOptions.actions,
      _.matchesProperty("name", "delete")
    );
    deleteButton.display = !!this.selection.length;
  }

  private async on_delete_click() {
    Swal.fire({
      title: "Êtes-vous sûr?",
      text: "Cette action est irréversible!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Oui, supprimer!"
    }).then(async result => {
      if (result.value) {
        await this.delete_selection();
        this.refresh_all_medias();
      }
    });
  }

  private async delete_selection() {
    for (let id of this.selection) {
      await this.mediaApi.deleteById(id).toPromise();
      this.selection = _.without(this.selection, id);
      this.refreshDeleteButton();
    }

    return;
  }

  async on_pick() {
    if (this.observer) {
      const medias: any[] = (await this.mediaApi
        .find({ where: { id: { inq: this.selection } } })
        .toPromise()) as Media[];
      this.observer.next(medias);
      this.observer.complete();
      this.close();
    }
  }

  close() {
    this.selection = [];
    this.refreshDeleteButton();
    this.linkModal.close();
  }

  constructor(public mediaApi: MediaApi, public uploadService: UploadService) {}

  ngOnInit() {
    this.get_all_medias();
  }

  ngOnDestroy() {}
}
